/* ============================================================================
   Furniva contact form.

   Two jobs, both progressive enhancements over a form that already works with
   scripting off:

     · reveal the order-number field for the topics that need one;
     · stop a second submission of the same enquiry.

   Validation itself is the browser's and Shopify's. Nothing here prevents a
   submit, rewrites a value, or posts anything — the form is an ordinary
   `{% form 'contact' %}` and Shopify handles it.
   ============================================================================ */
(function () {
  'use strict';

  var form = document.getElementById('fv-contact-form');
  if (!form) return;

  /* ------------------------------------------ failed-submit restoration -- */
  var draftKey = 'furniva-contact-draft';
  var failedState = form.querySelector('[data-fv-contact-error]');
  var successState = form.querySelector('[data-fv-contact-success]');

  function storageRemove() {
    try { window.sessionStorage.removeItem(draftKey); } catch (error) { /* storage may be unavailable */ }
  }

  if (successState) storageRemove();

  /* -------------------------------------------------- order number field -- */
  var orderField = form.querySelector('[data-fv-order-field]');
  var topics = Array.prototype.slice.call(form.querySelectorAll('input[name="contact[Topic]"]'));

  function syncOrderField() {
    if (!orderField) return;
    var chosen = topics.filter(function (t) { return t.checked; })[0];
    var wanted = !!(chosen && chosen.dataset.fvOrderTopic === 'true');
    orderField.hidden = !wanted;
  }

  topics.forEach(function (t) { t.addEventListener('change', syncOrderField); });

  if (failedState) {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(draftKey) || '{}');
      ['contact[name]', 'contact[phone]', 'contact[email]', 'contact[Order number]', 'contact[body]'].forEach(function (name) {
        var field = form.elements[name];
        if (field && typeof saved[name] === 'string') field.value = saved[name];
      });
      if (saved.topic) {
        topics.forEach(function (topic) { topic.checked = topic.value === saved.topic; });
      }
    } catch (error) {
      // Shopify still restores its standard fields; the draft is only an extra
      // safeguard for the custom topic and order-number fields.
    }
  }

  // Sync after optional restoration so the order field matches the recovered
  // topic rather than the first default topic.
  syncOrderField();

  /* ------------------------------------------------- duplicate submission -- */
  var button = form.querySelector('[data-fv-submit]');
  var label = form.querySelector('[data-fv-submit-label]');

  form.addEventListener('submit', function () {
    // Only once the browser is satisfied — a form that failed constraint
    // validation never fires submit, so the button is not left disabled.
    if (!button) return;
    var sending = button.dataset.fvSending === '1';
    if (sending) return;
    button.dataset.fvSending = '1';

    try {
      var chosen = topics.filter(function (topic) { return topic.checked; })[0];
      var draft = { topic: chosen ? chosen.value : '' };
      ['contact[name]', 'contact[phone]', 'contact[email]', 'contact[Order number]', 'contact[body]'].forEach(function (name) {
        var field = form.elements[name];
        draft[name] = field ? field.value : '';
      });
      window.sessionStorage.setItem(draftKey, JSON.stringify(draft));
    } catch (error) {
      // Submission must never depend on storage being available.
    }

    // Disabling immediately would drop the button's own name from the POST in
    // some browsers, so it is deferred by a tick — after the submission has
    // been serialised.
    window.setTimeout(function () {
      button.disabled = true;
      if (label) label.textContent = button.dataset.fvSendingLabel || 'Sending…';
    }, 0);
  });
})();
